// World themes (look + feel) and the 5 worlds / 20 levels of the adventure.
import { B } from './blocks.js';

export const THEMES = {
  plains: {
    sky: {
      top: '#2f7fe0', horizon: '#9fd4ff', bottom: '#cfe9ff', sun: '#fff1c8', sunDir: [0.55, 0.62, 0.35], sunSize: 0.055,
      clouds: [{ y: 96, coverage: 0.32, seed: 3, speed: 1.4 }, { y: 6, coverage: 0.62, seed: 11, speed: 0.8 }],
    },
    fog: ['#b4ddff', 90, 320],
    light: { hemiSky: '#d6ecff', hemiGround: '#7a6a4a', hemi: 1.35, sun: '#fff1d6', sunI: 2.6 },
    surface: B.GRASS, sub: B.DIRT, deep: B.STONE, ores: [B.COAL_ORE, B.IRON_ORE, B.GOLD_ORE],
    bridge: B.PLANKS, stone: B.COBBLE, pad: [B.NEON_LIME, B.NEON_YELLOW, B.NEON_CYAN, B.NEON_ORANGE],
    tree: 'oak', treeChance: 0.06,
    plants: [B.TALL_GRASS, B.TALL_GRASS, B.TALL_GRASS, B.FLOWER_RED, B.FLOWER_YELLOW, B.FLOWER_BLUE],
    plantChance: 0.22,
    mobs: ['slime', 'slime', 'zombie'], music: 'plains', ambient: 'leaves', landmark: 'bigTree',
    water: true, pumpkins: true,
  },
  desert: {
    sky: {
      top: '#3d84d6', horizon: '#ffe2b0', bottom: '#ffeccc', sun: '#fff0c0', sunDir: [0.3, 0.75, 0.4], sunSize: 0.07,
      clouds: [{ y: 96, coverage: 0.18, seed: 21, speed: 1.6 }, { y: 6, coverage: 0.45, seed: 25, speed: 0.6 }],
      cloudColor: '#fff6e8',
    },
    fog: ['#ffe2bc', 90, 310],
    light: { hemiSky: '#fff0d8', hemiGround: '#a08050', hemi: 1.1, sun: '#fff0d0', sunI: 2.25 },
    surface: B.SAND, sub: B.SANDSTONE, deep: B.SANDSTONE, ores: [B.GOLD_ORE, B.RED_SAND],
    bridge: B.SANDSTONE, stone: B.CHISELED_SANDSTONE, pad: [B.NEON_ORANGE, B.NEON_YELLOW, B.NEON_RED, B.GOLD_BLOCK],
    tree: 'palm', treeChance: 0.025, cactusChance: 0.035,
    plants: [B.DEAD_BUSH, B.DEAD_BUSH, B.TALL_GRASS],
    plantChance: 0.06,
    mobs: ['zombie', 'boom', 'slime'], music: 'desert', ambient: 'dust', landmark: 'pyramid',
    water: true,
  },
  snow: {
    sky: {
      top: '#5a8fd0', horizon: '#e4f0ff', bottom: '#f0f6ff', sun: '#ffffff', sunDir: [0.5, 0.45, 0.4], sunSize: 0.05,
      clouds: [{ y: 88, coverage: 0.48, seed: 31, speed: 1.0 }, { y: 6, coverage: 0.7, seed: 37, speed: 0.6 }],
    },
    fog: ['#e0eeff', 80, 290],
    light: { hemiSky: '#e6f0ff', hemiGround: '#8a9ab0', hemi: 1.45, sun: '#f4f8ff', sunI: 2.2 },
    surface: B.SNOW_GRASS, sub: B.DIRT, deep: B.STONE, ores: [B.IRON_ORE, B.DIAMOND_ORE, B.PACKED_ICE],
    bridge: B.DARK_PLANKS, stone: B.PACKED_ICE, pad: [B.NEON_CYAN, B.NEON_BLUE, B.NEON_WHITE, B.SNOW],
    tree: 'pine', treeChance: 0.07,
    plants: [B.SNOW_BUSH, B.SNOW_BUSH, B.TALL_GRASS],
    plantChance: 0.08,
    mobs: ['slime', 'flyer', 'zombie'], music: 'snow', ambient: 'snow', landmark: 'iceCastle',
    water: false, ice: true,
  },
  lava: {
    sky: {
      top: '#1a0606', horizon: '#a8301a', bottom: '#ff6a20', sun: '#ffb080', sunDir: [0.2, 0.3, 0.6], sunSize: 0.09,
      clouds: [], stars: 0,
    },
    fog: ['#7a2412', 50, 200],
    light: { hemiSky: '#ffb090', hemiGround: '#601808', hemi: 1.1, sun: '#ffc8a0', sunI: 2.0 },
    surface: B.MAGMA_ROCK, sub: B.MAGMA_ROCK, deep: B.BASALT, ores: [B.MAGMA, B.GOLD_ORE, B.RUBY_ORE, B.OBSIDIAN],
    bridge: B.BASALT, stone: B.OBSIDIAN, pad: [B.NEON_RED, B.NEON_ORANGE, B.MAGMA, B.NEON_YELLOW],
    tree: 'crystal', treeChance: 0.03,
    plants: [B.FIRE_FLOWER, B.MUSHROOM, B.CRYSTAL_SHARD],
    plantChance: 0.07,
    mobs: ['boom', 'flyer', 'slime'], music: 'lava', ambient: 'embers', landmark: 'volcano',
    lavaSea: true, slimeColor: ['#ff7a2a', '#a8300a'],
  },
  glitch: {
    sky: {
      top: '#05030f', horizon: '#3a1260', bottom: '#120626', sun: '#ff9af0', sunDir: [-0.3, 0.4, 0.7], sunSize: 0.08,
      clouds: [], stars: 1.0, nebula: '#7a2aa0',
    },
    fog: ['#2a0e48', 60, 240],
    light: { hemiSky: '#c8a0ff', hemiGround: '#301050', hemi: 1.2, sun: '#ffd0f8', sunI: 2.1 },
    surface: B.VOID_STONE, sub: B.VOID_STONE, deep: B.OBSIDIAN, ores: [B.CRYSTAL, B.GLITCH, B.DIAMOND_ORE],
    bridge: B.VOID_BRICK, stone: B.OBSIDIAN, pad: [B.NEON_PURPLE, B.NEON_PINK, B.NEON_CYAN, B.GLITCH],
    tree: 'crystal', treeChance: 0.05,
    plants: [B.CRYSTAL_SHARD, B.CRYSTAL_SHARD, B.MUSHROOM],
    plantChance: 0.06,
    mobs: ['flyer', 'zombie', 'boom'], music: 'glitch', ambient: 'glitch', landmark: 'glitchTower',
    slimeColor: ['#c070ff', '#6020a0'],
  },
};

// Topic weights per world (parents can switch topics off in Settings)
export const WORLDS = [
  {
    id: 1, theme: 'plains', name: 'Grassy Glade', color: '#5cc93b', dark: '#2f7d1c',
    blurb: 'Rolling sky islands full of flowers… and bouncy slimes!',
    topics: { add: 3, sub: 2, mul: 2, time: 1, pattern: 1, shapes: 1, spell: 1 },
    tables: [2, 5, 10],
    boss: { kind: 'slime', name: 'KING SLIME', hp: 3 },
    levels: ['First Steps', 'Bouncy Bridges', 'Slime Valley'],
  },
  {
    id: 2, theme: 'desert', name: 'Desert Dunes', color: '#f0b440', dark: '#a8701a',
    blurb: 'Hot sand, ancient pyramids and sneaky Boom Bots.',
    topics: { add: 2, sub: 2, mul: 3, missing: 1, word: 2, spell: 1, place: 1, fraction: 1 },
    tables: [2, 3, 4, 5, 10],
    boss: { kind: 'golem', name: 'SANDSTONE GOLEM', hp: 4 },
    levels: ['Sandy Steps', 'Pyramid Path', 'Cactus Canyon'],
  },
  {
    id: 3, theme: 'snow', name: 'Frosty Peaks', color: '#7fd0ff', dark: '#2a7ab0',
    blurb: 'Slippery ice bridges and snowy mountains in the clouds.',
    topics: { mul: 3, div: 2, word: 2, spell: 2, time: 1, fraction: 1, add: 1, sub: 1 },
    tables: [2, 3, 4, 5, 6, 8, 10],
    boss: { kind: 'ice', name: 'ICE TITAN', hp: 4 },
    levels: ['Frozen Falls', 'Icy Slides', 'Blizzard Bridge'],
  },
  {
    id: 4, theme: 'lava', name: 'Lava Caverns', color: '#ff6a2a', dark: '#a8300a',
    blurb: 'Jump over bubbling lava in the fiery deep!',
    topics: { mul: 3, div: 2, missing: 2, word: 2, place: 1, sub: 1, add: 1, spell: 1 },
    tables: [2, 3, 4, 5, 6, 7, 8, 9, 10],
    boss: { kind: 'magma', name: 'MAGMA KING', hp: 5 },
    levels: ['Ember Edge', 'Magma Maze', 'Volcano Vault'],
  },
  {
    id: 5, theme: 'glitch', name: 'Glitch Kingdom', color: '#b15eff', dark: '#5b1a8f',
    blurb: "The Glitch King's castle floats in deep space. Only {name} can stop him!",
    topics: { mul: 3, div: 2, missing: 2, word: 2, add: 1, sub: 1, spell: 1, time: 1, fraction: 1, pattern: 1, place: 1 },
    tables: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    boss: { kind: 'glitch', name: 'THE GLITCH KING', hp: 6 },
    levels: ['Pixel Path', 'Crystal Chaos', 'Castle Gates'],
  },
];

export function levelId(w, l) {
  return `${w}-${l}`;
}
export function parseLevelId(id) {
  const [w, l] = id.split('-');
  if(['mine','sky','temple'].includes(l))return {w:1,l:1};
  return { w: parseInt(w, 10), l: l === 'B' ? 4 : parseInt(l, 10) };
}
export function allLevelIds() {
  const out = [];
  for (const W of WORLDS) {
    for (let l = 1; l <= 3; l++) out.push(`${W.id}-${l}`);
    out.push(`${W.id}-B`);
  }
  return out;
}
export function nextLevelId(id) {
  const ids = allLevelIds();
  const i = ids.indexOf(id);
  return i >= 0 && i < ids.length - 1 ? ids[i + 1] : null;
}
export function levelName(id) {
  const special={mine:'Crystal Mine Express',sky:'Ember’s Sky Rescue',temple:'The Secret Temple'}[id.split('-')[1]];if(special)return special;
  const { w, l } = parseLevelId(id);
  const W = WORLDS[w - 1];
  if (l === 4) return W.boss.name;
  return W.levels[l - 1];
}
